module.exports = __webpack_public_path__ + "img/classpicture.5b6be085.jpg";